import { type FC, useMemo } from 'react';
import { ObjectToolbar } from 'src/blocks/object-toolbar';

import { buildAutomationsRegisterToolbarConfig } from './registerToolbarConfig';

interface Props {
  title: string;
}

/**
 * Object toolbar for the Automations register, mounted only when the
 * `object_toolbar` flag is on. Automations is an integrations landing page (a
 * static card grid, not a data table), so it has no export, no create, and no
 * ribbon — the toolbar is title-only. `useExportOptions` is intentionally
 * omitted; there is no `ExportButton` on this page for it to share a path with
 * (CUS-136).
 */
export const AutomationsRegisterToolbar: FC<Props> = ({ title }) => {
  const toolbarConfig = useMemo(
    () => buildAutomationsRegisterToolbarConfig({ title, exportOptions: [] }),
    [title]
  );

  return <ObjectToolbar config={toolbarConfig} />;
};
